import React from 'react';
import { ESTADO_ICONO, ESTADO_LABEL, ESTADO_PILL } from 'lib/estadoUi';

// Ícono único por estado en TODA la app (administración y asistente): la
// misma "Falla" no puede verse con dos íconos distintos según la pantalla.
// Falla = AlertOctagon (octágono con !). El asistente puede importar este mapa.
export { ESTADO_ICONO };

const TAMANO = {
  sm: { caja: 'gap-1 px-2 py-0.5 text-xs', icono: 12 },
  lg: { caja: 'gap-1.5 px-3 py-1 text-sm', icono: 16 },
};

// Píldora de estado con color E ícono (no depender solo del color).
export default function EstadoPill({ estado, size = 'sm', className = '' }) {
  const Icono = ESTADO_ICONO[estado];
  const t = TAMANO[size] || TAMANO.sm;
  return (
    <span className={`inline-flex shrink-0 items-center rounded-full border font-semibold ${t.caja} ${
      ESTADO_PILL[estado] || 'border-border bg-muted text-muted-foreground'} ${className}`}>
      {Icono && <Icono size={t.icono} strokeWidth={2.5} aria-hidden="true" />}
      {ESTADO_LABEL[estado] || 'Sin dato'}
    </span>
  );
}

// Marcas de trazabilidad: tardío y anulada.
export function MarcaTardio() {
  return (
    <span title="Registrado después del día de la inspección"
      className="inline-flex items-center rounded-full border border-warning/50 bg-warning/10 px-2 py-0.5 text-[11px] font-semibold text-warning-foreground">
      Tardío
    </span>
  );
}

export function MarcaAnulada() {
  return (
    <span className="inline-flex items-center rounded-full border border-border bg-muted px-2 py-0.5 text-[11px] font-semibold text-muted-foreground">
      Anulada
    </span>
  );
}
